<!-- app.component.html -->

<header class="main-header">

  <div class="nav-container">

    <!-- BRAND -->
    <div class="brand-box">

      <div class="logo-wrapper">
        <img src="assets/suncrestnewlogo.png"
             alt="Suncrest Global Logo"
             class="header-image-logo">

        <span class="online-dot"></span>
      </div>

      <div class="brand-text">
        <div class="main-title">
          <span class="orange-gold">SUNCREST</span>
          <span class="green-text">GLOBAL PRIVATE LIMITED</span>
        </div>

        <span class="tagline">
          Pure by Nature. Proven by Trust.
        </span>
      </div>

    </div>

    <!-- MOBILE MENU BUTTON -->
    <div class="menu-toggle" (click)="toggleMenu()">

      <span></span>
      <span></span>
      <span></span>

    </div>

    <!-- NAVIGATION -->
    <nav class="nav-links" [class.active]="menuOpen">

      <a routerLink="/home">HOME</a>

      <a routerLink="/about">ABOUT US</a>

      <a routerLink="/products">PRODUCTS</a>

      <a routerLink="/contact">CONTACT US</a>

      <a href="#" class="cta-btn">
        GET A QUOTE
      </a>

    </nav>

  </div>

</header>

<!-- Router -->
<router-outlet></router-outlet>

<!-- Why Choose -->
<section class="why-choose">

  <div class="section-title">
    <h2>
      Bringing Indian Purity to the World:
      <span>The Suncrest Advantage</span>
    </h2>
  </div>

  <div class="features-grid">

    <div class="feature-item card-gold">
      <div class="icon-circle">🌱</div>
      <h4>Farm Sourcing</h4>
      <p>
        Direct farm-to-port logistics ensuring peak freshness and traceability.
      </p>
    </div>

    <div class="feature-item card-orange">
      <div class="icon-circle">🛡️</div>
      <h4>Reliable Quality</h4>
      <p>
        Multi-stage testing ensuring compliance with global food standards.
      </p>
    </div>

    <div class="feature-item card-green">
      <div class="icon-circle">📦</div>
      <h4>Customized Solutions</h4>
      <p>
        Tailored bulk packaging and private labeling for your brand.
      </p>
    </div>

    <div class="feature-item card-teal">
      <div class="icon-circle">📡</div>
      <h4>Modern Logistics</h4>
      <p>
        Real-time updates bridging traditional trade with modern efficiency.
      </p>
    </div>

  </div>

</section>
<!-- PRODUCTS SECTION -->

<section class="products-carousel">

  <div class="section-title">
    <h2>
      Our <span>Best Products</span>
    </h2>
  </div>

  <div class="carousel-container">

    <div class="carousel-track"
         [style.transform]="'translateX(-' + currentSlide + 'px)'">

      <div class="p-card" *ngFor="let p of products">

        <div class="product-img-box">
          <img [src]="p.img" [alt]="p.name">
        </div>

        <h5>{{p.name}}</h5>

        <!-- <span class="p-tag">
          Organic
        </span> -->

      </div>

    </div>

  </div>

</section>

<!-- Footer -->
<footer class="main-footer">
  <p>&copy; 2026 Suncrest Global Pvt. Ltd.</p>
</footer>